import { render, staticRenderFns } from "./RecommenPost.vue?vue&type=template&id=70094a39&scoped=true&"
import script from "./RecommenPost.vue?vue&type=script&lang=js&"
export * from "./RecommenPost.vue?vue&type=script&lang=js&"
import style0 from "./RecommenPost.vue?vue&type=style&index=0&id=70094a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70094a39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70094a39')) {
      api.createRecord('70094a39', component.options)
    } else {
      api.reload('70094a39', component.options)
    }
    module.hot.accept("./RecommenPost.vue?vue&type=template&id=70094a39&scoped=true&", function () {
      api.rerender('70094a39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/RecommenPost.vue"
export default component.exports